<template>
  <div>
    <h1>test</h1>
    <button type="button" class="btn btn-primary">（首选项）Primary</button>
    <span class="glyphicon glyphicon-search" aria-hidden="true"></span>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>